<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<!-- <div class="pull-right">
				<b-button
					variant="outline-primary"
					@click="excelExport('whDocTable', itemObject.regNumber)"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>

				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}}
				</b-button>
			</div> -->
			<div class="clearfix"></div>

		</div>
		<div class="doc-body">
			<b-card class="p-3">
				<b-row class="mb-3">
					<b-col></b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center day-wrapper">
							{{formatDate(itemObject.regDate, 'DD')}}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center ">
							{{formatDate(itemObject.regDate, 'MM')}}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center">
							{{formatDate(itemObject.regDate, 'YYYY')}}
						</div>
					</b-col>
				</b-row>
				<div class="text-center">
					<h3 class="font-weight-bold text-uppercase">№: <span class="small">{{itemObject.regNumber}}</span>
					</h3>
				</div>
				<div class="text-right">
					<p>
						<strong>{{$t('incomeFilter.contragent')}}: </strong> {{itemObject.fromContragentName}}
					</p>
				</div>
				<b-row class="mb-3">
					<b-col cols="6">
					<b-button
						variant="warning"
						@click="saveChanges"
						class="mr-2"
					>
						<i class="fa fa-stop-circle"></i>
						Сохранить изменения
					</b-button>
					<b-button
							variant="success"
							@click="createWholesaleDoc"
							class="mr-2"
						>
						<i class="fa fa-share-square"></i>
						Создать документ для оптовой продажи
					</b-button>
					</b-col>
					<b-col cols="2">
						<b-form-checkbox
						class="mt-1"
						id="checkbox-1"
						v-model="selectedAll"
						name="checkbox-1"
						value="accepted"
						unchecked-value="not_accepted"
						>
						Выбрать все
					</b-form-checkbox>
					</b-col>
					<b-col cols="4" class="bg-light pl-4 pt-2">
						<b-row>
							<b-col><label>{{$t('goods.create.date-expiration')}}</label></b-col>
							<b-col><date-picker v-model="itemObject.expiredDate"
								 lang="ru"
								 size="sm"
								 placeholder="dd-mm-yyyy"
								 valueType="format"
								 format="DD-MM-YYYY"
								></date-picker>
							</b-col>
						</b-row>

					</b-col>
				</b-row>
				<div class="generalTableClass documentItems">
					<table class="table" id="whDocTable">
						<thead>
						<tr>
							<th> №</th>
							<th>{{$t('goods.artikul')}}</th>
							<th>{{$t('goods.barcode')}}</th>
							<th>{{$t('incomes.create.product')}}</th>
							<th  style="text-align: center">{{$t('comment')}}</th>
							<th style="text-align: center">Кол-база</th>
							<th style="text-align: center">{{$t('incomes.create.count')}}</th>
							<th style="text-align: center;width:17%">{{$t('incomes.create.count')}}</th>
							<th  style="text-align: center">{{$t('comment')}}</th>

						</tr>
						</thead>
						<tbody>
						<template v-for="(item,index) in itemObject.orderItems">
							<tr  :key="index" :class="[index%2 == 0 ? 'bg-light':'bg-white',sendErorrArray.indexOf(index)>-1?'b-color':'',
								sendErorrNullArray.indexOf(index)>-1?'b-color-2':'']">
							<td>{{index+1}}</td>
							<td>{{item.itemArtikul}}</td>
							<td>{{item.itemBarcode}}</td>
							<td>{{item.itemName}}</td>
							<td>{{item.comment}}</td>
							<td style="text-align: center">{{ getQtyBaza(item.dataFromItemstatus)}}</td>
							<td style="text-align: center">
								<span class="mr-2">{{item.contragentOrderQty}}</span>
								<i  v-if="item.contragentOrderQty == getAllManagerQty(item.dataFromItemstatus)" style="color: green;"
								class="fa fa-check"></i>
								<i v-else style="color: red;"
								class="fa fa-question-circle"></i>
							</td>
							<td style="text-align: center">

							</td>
							<td>
								<b-form @submit="e => e.preventDefault()">
									<b-form-input
										class="p-3"
										size="sm"
										v-model="item.managerComment"
										name="comment"
										autocomplete="off"
										:placeholder="$t('comment')"
									>
									</b-form-input>
								</b-form>
							</td>
						</tr>
						<tr v-for="(itembaza , indexbaza) in item.dataFromItemstatus" :key="
						index+indexbaza+item.itemId+item.dataFromItemstatus.length+item.contragentOrderQty"
						 :class="(index%2) == 0 ? 'bg-light':'bg-white'">
							<td colspan="4"></td>
							<td style="text-align: center" colspan="2">
								<strong class="text-warning">{{$t('incomes.balance')}} : {{ itembaza.remaining }}</strong>
							<br>
								<strong class="text-success">{{$t('incomes.create.price')}} : {{ itembaza.price }}</strong>
							</td>
							<td style="text-align: center">

							</td>
							<td>
								<b-col>
								<b-input-group size="sm">
									<b-form-input
									@input="checkCountManager($event, item.contragentOrderQty)"
									v-model.number="itembaza.managerQty"
												size="sm" autocomplete="off"
													type="number"></b-form-input>
									<b-input-group-addon>
										<b-button size="sm" disabled>
											{{ item.unitName }}
										</b-button>
									</b-input-group-addon>
								</b-input-group>
								</b-col>
							</td>
							<td></td>
						</tr>
						</template>
						</tbody>
					</table>

					<div class="text-left mt-2">
					<p>
						<strong>{{$t('comment')}}: </strong> {{itemObject.comment}}
					</p>
				</div>

				</div>
			</b-card>
		</div>
	</b-container>

</template>

<script>
	import ContrAgentService from "../../services/contragent.service";
	import moment from 'moment'

	export default {
		name: "RequestDocumentShow",
		data() {
			return {
				itemObject: {},
				loader: false,
				selectedAll: false,
				sendErorrArray:[],
				sendErorrNullArray:[]
			}
		},
		watch: {
			'selectedAll' :{
				async handler(newVal) {
					await this.selectAll(newVal);
				}
			}
		},
		methods: {
			createWholesaleDoc() {
				if(!this.itemObject.expiredDate) {
					this.$vs.notify({
					title: 'Пожалуйста, выберите дату истечения',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
					});
					return
				}else {
					let d1 = new Date(this.itemObject.expiredDate.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"))
					let d2 = new Date()
					if(d1.setHours(0,0,0,0) < d2.setHours(0,0,0,0)) {
						this.$vs.notify({
						title: 'Пожалуйста, выберите правильную дату',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
						});
						return
					}

				}
				let sendCountError = false;
				let sendCountNoll = false;
				let sendErrorOstatka = false
				let totalManagerOrderQty = 0
				this.itemObject.orderItems.forEach(async  (el, index) => {
				el.managerOrderQty =  await this.getAllManagerQty(el.dataFromItemstatus);
				totalManagerOrderQty += el.managerOrderQty
				if(el.managerOrderQty > 0 && el.dataFromItemstatus.length>0) {
					this.sendErorrNullArray.splice(index, 1)
					if(parseFloat(el.managerOrderQty)>parseFloat(el.contragentOrderQty)) {
					this.sendErorrArray.push(index)
					sendCountError = true
					}else{
						this.sendErorrArray.splice(index, 1)
					}
				}else {
					if(el.dataFromItemstatus.length>0) {
						if(this.sendErorrNullArray.indexOf(index) == -1) {
						this.sendErorrNullArray.push(index)
						}
						sendCountNoll = true
					}
				}
				if(el.dataFromItemstatus.length>0) {
					el.dataFromItemstatus.forEach(el => {
						if(el.remaining < el.managerQty) {
							sendErrorOstatka = true
						}
					})
				}
				})
				setTimeout(()=> {
					if(sendCountNoll) {
						this.$vs.notify({
							title: 'Количество отправлений 0',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
						return
					}
					if(sendCountError) {
						this.$vs.notify({
							title: 'Количество отправлений больше, чем количество заказов',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
						return
					}
					if(sendErrorOstatka) {
						this.$vs.notify({
							title: 'Количество отправлений больше, чем остатка склада или магазина',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
						return
					}
					if(totalManagerOrderQty>0) {
							ContrAgentService.createWholeSaleDoc(this.itemObject).then(res => {
							this.$vs.notify({
								title: 'Новый оптовый документ успешно создан',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							});
							this.$router.back(-1)

							}).catch(e => {
								this.$vs.notify({
								title: 'ERROR SERVER',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
								})
								return
							});
						}else {
							this.$vs.notify({
								title: 'Количество отправлений 0',
								color: 'danger',
								icon: 'close',
								position: 'top-right'
								});
							return
						}
				},50)


			},
			getAllManagerQty(item) {
				let total = 0
				item.forEach(el => {
					if(el.managerQty) {
						total += parseFloat(el.managerQty)
					}
				})
				return total
			},
			getQtyBaza(item) {
				let total = 0
				item.forEach(el => {
					total += parseFloat(el.remaining)
				})
				return total
			},
			checkCountManager(managerCount, contragentCount) {
				if(managerCount > contragentCount) {
					this.$vs.notify({
						text: 'Количество заказов: ' + contragentCount,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			selectAll(newVal) {
				this.itemObject.orderItems.forEach(el => {
					if(el.dataFromItemstatus.length == 1) {
						if(newVal == 'accepted') {
							el.dataFromItemstatus[0].tempManagerOrder = el.dataFromItemstatus[0].managerQty
							el.dataFromItemstatus[0].managerQty = el.contragentOrderQty
						}else {
							el.dataFromItemstatus[0].managerQty = el.dataFromItemstatus[0].tempManagerOrder
						}
					}else {
						return
					}
				})
			},
			async saveChanges() {
				let data = []
				let obj ;
				this.itemObject.orderItems.forEach( el => {
					obj = {
						itemId: el.itemId,
						managerComment: el.managerComment,
						managerQty: el.managerQty
					}
					data.push(obj)
				})
				await ContrAgentService.editManagerOrderDoc(this.$route.params.id, data)
				await this.$router.push({path:'/contragents/orders'})
			},
			excelExport(tableID, filename = '') {

				let downloadLink;

				let dataType = 'text/xls;charset=UTF-8';
				//var dataType = 'application/vnd.ms-excel';
				let tableSelect = document.getElementById(tableID);
				let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

				// Specify file name
				filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';
				// Create download link element
				downloadLink = document.createElement("a");

				document.body.appendChild(downloadLink);

				if (navigator.msSaveOrOpenBlob) {
					let blob = new Blob(['\ufeff', tableSelect], {
						encoding: "utf-8",
						type: dataType
					});
					navigator.msSaveOrOpenBlob(blob, filename);
				} else {
					// Create a link to the file
					downloadLink.href = 'data:' + dataType + ', ' +  tableHTML;

					// Setting the file name
					downloadLink.download = filename;

					//triggering the function
					downloadLink.click();
				}

			},
			formatDate(date, format = 'DD-MM-YYYY') {
				if (date) {
					const split = date.split(' ');
					date = split[0];
					const revers = date.split('-');
					date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
					return moment(String(date)).format(format)
				}
			},
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
			async getRequestItem() {
				try {
					let res = await ContrAgentService.getDocumentItems(this.$route.params.id)
					if(res.data)
					this.itemObject = res.data
					else
					this.itemObject = {}
				}catch(e) {
					this.itemObject = {}
				}
			},
		},
		mounted() {
			this.getRequestItem();
		}

	}
</script>

<style scoped lang="scss">
.b-color {
	border:3px solid red !important;
}
.b-color-2 {
	border:3px solid blue !important;
}

@page  {
	margin: 1cm;
}

	@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
	}

	.generalTableClass {
	.table {
	td, th {
		font-size: 12px;
	}
	}
	}
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
